import { BrowserRouter as Router } from 'react-router-dom';
import { Routes as AppRoutes } from './index.routes';

/**
 * Main Routes Component
 * Wraps the application routes with BrowserRouter
 */
const Routes = () => {
  return (
    <Router>
      <AppRoutes />
    </Router>
  );
};

export { Routes };
